import { render, staticRenderFns } from "./ChangeCategoryModalConfirm.vue?vue&type=template&id=08bed948&"
import script from "./ChangeCategoryModalConfirm.vue?vue&type=script&lang=js&"
export * from "./ChangeCategoryModalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports